module.exports = __webpack_public_path__ + "img/blue_078.192b093b.png";